module.exports = __webpack_public_path__ + "img/left_suc.353fc254.png";